<template lang="pug">
v-card.summary-card(
  outlined,
  :class="cardClasses"
)
  v-card-text.summary-card__content
    v-icon.summary-card__icon(v-if="icon", :size="iconSize", :class="iconClasses") {{ icon }}
    .summary-card__title {{ title }}
    .summary-card__value-row
      span.summary-card__value {{ value }}
      span.summary-card__percentage(v-if="percentage") {{ percentage }}
</template>

<script>
export default {
  name: "SummaryCard",

  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    percentage: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    iconSize: {
      type: Number,
      default: 22
    },
    variant: {
      type: String,
      default: "",
      validator: value =>
        [
          "",
          "neutral",
          "primary",
          "success",
          "danger",
          "warning",
          "highlight",
          "filled-success"
        ].includes(value)
    },
    iconVariant: {
      type: String,
      default: "",
      validator: value => ["", "success", "danger", "android", "ios", "windows"].includes(value)
    }
  },

  computed: {
    cardClasses() {
      return {
        "summary-card--with-icon": !!this.icon,
        [`summary-card--${this.variant}`]: !!this.variant
      };
    },

    iconClasses() {
      return {
        [`summary-card__icon--${this.iconVariant}`]: !!this.iconVariant
      };
    }
  }
};
</script>

<style scoped>
.summary-card {
  min-height: 98px;
  height: 98px;
  max-height: 98px;
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  border-radius: 18px 6px 18px 6px !important;
}

.summary-card__title {
  color: #31496b;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.summary-card__value-row {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
}

.summary-card__value {
  color: #0a1f44;
  font-size: 20px;
  font-weight: 700;
}

.summary-card__percentage {
  color: #9aa8b8;
  font-size: 20px;
  font-weight: 600;
}

.summary-card--with-icon .summary-card__content {
  height: 100%;
  padding-right: 42px;
  position: relative;
}

.summary-card--with-icon .summary-card__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
}

.summary-card--neutral {
  border-color: #d2deed !important;
}

.summary-card--primary {
  border-color: #8bb8ea !important;
}

.summary-card--success {
  border-color: #9be8ca !important;
}

.summary-card--danger {
  border-color: #f2b0b0 !important;
}

.summary-card--warning {
  border-color: #f2d372 !important;
}

.summary-card--highlight {
  border-color: #a8eed5 !important;
}

/* Variante de destaque: fundo sólido, borda na mesma cor do conteúdo */
.summary-card--filled-success {
  background-color: #1d6a5e !important;
  border-color: #1d6a5e !important;
}

.summary-card--filled-success .summary-card__title,
.summary-card--filled-success .summary-card__value {
  color: #fff !important;
}

.summary-card--filled-success .summary-card__percentage {
  color: rgba(255, 255, 255, 0.85) !important;
}

.summary-card__icon--success {
  color: #2e7d32 !important;
}

.summary-card__icon--danger {
  color: #c62828 !important;
}

.summary-card__icon--android {
  color: #3ddc84 !important;
}

.summary-card__icon--ios {
  color: #6f7d8c !important;
}

.summary-card__icon--windows {
  color: #1e88e5 !important;
}
</style>
